import request from '../api/request'

// 分页查询试题
export function queryQuestionList(param) {
  return request({
    url: '/question/list',
    method: 'get',
    params: param
  })
}

// 新增试题
export function addQuestion(data) {
    return request({
      url: '/question/addQuestion',
      method: 'post',
      data: data
    })
}
// 修改试题
export function modifyQuestion(data) {
    return request({
      url: '/question',
      method: 'put',
      data: data
    })
}


//查询试题类型
export function queryQuestionTypeList(param) {
    return request({
      url: '/question/queryTypes',
      method: 'get',
      params: param
    })
}

//新增试题类型
export function addQuestionType(data) {
    return request({
      url: '/question/addType',
      method: 'post',
      data: data
    })
}

//修改试题类型
export function modifyQuestionType(data) {
    return request({
      url: '/question/updateType',
      method: 'put',
      data: data
    })
}

//查询试题科目
export function querySubjectList(param) {
    return request({
      url: '/question/subject/list',
      method: 'get',
      params: param
    })
}

//查询所有试题科目
export function queryAllSubjects(param) {
    return request({
      url: '/question/subject/listAll',
      method: 'get',
      params: param
    })
}

//新增试题科目
export function addSubject(data) {
    return request({
      url: '/question/addSubject',
      method: 'post',
      data: data
    })
}

//修改试题科目
export function modifySubject(data) {
    return request({
      url: '/question/updateSubject',
      method: 'put',
      data: data
    })
}

//单独修改试题科目状态
export function updateSubjectsState(subjectId, state) {
    return request({
      url: `/question/updateSubjectsState/${subjectId}/${state}`,
      method: 'get',
    })
}

//随机抽取题目
export function randomQues(data) {
    return request({
      url: '/question/rand',
      method: 'post',
      data: data
    })
}

// 删除题目
export function deleteQues(questionIds) {
    return request({
      url: '/question/'+ questionIds,
      method: 'delete',
    })
}